import type { ClientKind } from '@/kinds/kind'
import { afterPatch, apply, defaults, displayName, initialStatus, validate } from './apply'
import { quickAddParse } from './parse'
import { taskSpec, taskStatus, type TaskSpec, type TaskStatus } from './schema'
import { TaskDetail, TaskForm, TaskListRow } from './components'

export const taskKind: ClientKind<TaskSpec, TaskStatus> = {
  name: 'Task',
  version: 1,
  spec: taskSpec,
  status: taskStatus,
  defaults,
  validate,
  initialStatus,
  displayName,
  apply,
  afterPatch,
  actions: ['complete', 'drop', 'reopen', 'move', 'defer', 'start', 'stop', 'touch', 'done_now', 'convert'],
  ListRow: TaskListRow,
  Detail: TaskDetail,
  Form: TaskForm,
  quickAddParse,
  workspaceScoped: true,
}

export * from './schema'
export type { TaskResource } from './apply'
